import axios from 'axios';
import {
	keycloak
} from '../keycloak';

const apiClient = axios.create({
	baseURL: process.env.VUE_APP_APIURL,
	timeout: 10000,
});

apiClient.interceptors.request.use(
	(config) => {
		if (!config.noAuth) {
			const token = keycloak.token;
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
				config.headers['Accept'] = 'application/json';
				config.withCredentials = false;
			} else {
				return Promise.reject(new Error('Authentication required.'));
			}
		} else {
			config.headers['Accept'] = 'application/json';
			config.withCredentials = false;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

apiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		console.log('Interceptor triggered:', error);
		if (error.response) {
			if (error.response.status === 401) {
				if(localStorage.getItem('lang') !== null){
					window.location.href = '/login';
				} else {
					window.location.href = '/';
				}
			} else if (error.response.data && error.response.data.error === 'no_user') {
				location.reload();
			}
		} else {
			console.error('Network error or server did not respond:', error);
			alert('An error occurred. Please try again later.');
		}
		return Promise.reject(error);
	}
);

export default apiClient;